module.exports = __webpack_public_path__ + "static/media/clock.8ac9906a.svg";